import { observer } from 'mobx-react-lite'
import { links } from '@/utils/link'
import { type ClientUserDetailsViewModel } from '@/features/client-user-management/ClientUserDetails/ClientUserDetailsViewModel'
import { ClientUserDetailsInformation } from '@/features/client-user-management/components/ClientUserDetailsInformation'
import { ClientUserAdvisorsContainer } from './ClientUserAdvisorsContainer'

export interface ClientUserDetailsInformationContainerProps {
  vm: ClientUserDetailsViewModel
}

export const ClientUserDetailsInformationContainer = observer(
  function ClientUserDetailsInformationContainer({
    vm,
  }: ClientUserDetailsInformationContainerProps) {
    return (
      <>
        <ClientUserDetailsInformation
          displayName={vm.member.displayName}
          email={vm.member.email}
          phone={vm.member.phone}
          lastSeen={vm.member.lastSeen}
          dateModified={vm.member.dateModified}
          dateCreated={vm.member.dateCreated}
        />
        {vm.clientAssignmentVm.shouldShowAdvisors && (
          <ClientUserAdvisorsContainer
            vm={vm.clientAssignmentVm}
            getAdvisorLink={links.clientUserDetails}
          />
        )}
      </>
    )
  },
)
